import { cn } from '@skupreme/shared/ui';
import type React from 'react';
import { useMemo } from 'react';
import { StylingUtility } from '@utility/style-utility';

export interface IColoredPillProps
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Any CSS colour, often from server metadata: the text takes it, the fill a faint tint of it. */
  color?: string;
  mini?: boolean;
  children: React.ReactNode;
}

export const ColoredPill: React.FC<IColoredPillProps> = ({
  color,
  mini,
  children,
  className,
  style,
  ...rest
}) => {
  const background = useMemo(() => {
    if (color && ['rgb(255,255,255)', '#FFFFFF', '#ffffff'].includes(color)) {
      return '#000000';
    }
    /* Kit tokens arrive as `var(--sk-…)`, which the hex parser can't read. */
    if (color?.startsWith('var(')) {
      return `color-mix(in srgb, ${color} 10%, transparent)`;
    }
    if (color) {
      return StylingUtility.getLowerOpacityColor(color);
    }
    return 'var(--sk-fill-tertiary)';
  }, [color]);

  return (
    <div
      {...rest}
      className={cn(
        'sk:flex sk:w-fit sk:items-center sk:justify-center sk:rounded-[15px] sk:whitespace-nowrap',
        mini
          ? 'sk:h-5 sk:gap-[5px] sk:p-1.5 sk:text-xs'
          : 'sk:gap-[7px] sk:px-2 sk:py-[3px]',
        className,
      )}
      style={{ background, color, ...style }}
    >
      {children}
    </div>
  );
};
